<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/components/views/packing_house/quality_control/process/show_inspect/quality_group_details.yml"
  lang="yaml"
></i18n>
<template>
  <h1 class="text-lg font-semibold text-gray-900 mt-8">
    <span class="space-icon"></span
    >{{ quality_attribute?.crop_attribute?.name }}
  </h1>
  <div class="mt-8 flex flex-col" v-if="ranges">
    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div
          class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
        >
          <table class="table">
            <thead class="table-header">
              <tr>
                <th
                  scope="col"
                  v-for="range in ranges"
                  :key="range.id"
                  class="table-header-cell text-center px-1.5"
                >
                  <div class="tooltip">
                    <p>
                      {{ range.label }}
                    </p>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr class="table-row divide-x">
                <td
                  class="table-cell-main text-center px-1.5"
                  v-for="range in ranges"
                  :key="range.id"
                >
                  {{ cellValue(range) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div />
</template>

<script>
export default {
  name: "AttributeRanges",
  data: () => ({
    open: true,
  }),
  props: {
    inspect: { type: Object, required: true },
    quality_attribute: { type: Object, required: true },
  },
  computed: {
    general: function () {
      return this.inspect.quality_generals.find(
        (general) =>
          general.quality_attribute_id ==
          this.quality_attribute.id
      );
    },
    ranges: function () {
      return this.quality_attribute.quality_attribute_ranges ?? [];
    },
    samplings: function () {
      return this.inspect?.quality_samplings ?? [];
    },
  },
  methods: {
    cellValue: function (range) {
      let total = this.general?.quality_general_ranges?.find(
        (gr) => gr.quality_attribute_range_id == range.id
      )?.total;
      if (total) return total;
    },
  },
};
</script>
